import {
    FORM_INVALID_TRANSITION_PURCHASE_PERSONAL_DETAILS,
    FORM_VALID_TRANSITION_PURCHASE_PERSONAL_DETAILS,
    PURCHASE_PERSONAL_DETAILS_EDIT,
    PURCHASE_PERSONAL_DETAILS_SET_VALID,
    PURCHASE_PERSONAL_DETAILS_SET_VALUE,
    PURCHASE_PERSONAL_DETAILS_SET_VALUE_WITHOUT_VALIDATION,
} from '../../actions/sizotsaFuneralCover/personalDetails';
import { FIELD_STATUS, FORM_STATUS } from '../status';

export const initCountry = 'Eswatini';
const nationalityLabel = [
    'Botswana',
    'South Africa',
    'Ghana',
    'Kenya',
    'Malawi',
    'Namibia',
    'Nigeria',
    'Rwanda',
    'South Sudan',
    'Tanzania',
    'Uganda',
    'Zimbabwe',
];
export const initPurchasePersonalDetails = {
    formStatus: FORM_STATUS.INVALID,
    isPurchasePersonalDetailsEdit: false,
    form: {
        title: { value: null, error: null, status: null },
        firstName: { value: null, error: null, status: null },
        middleName: { value: null, error: null, status: FORM_STATUS.VALID },
        surname: { value: null, error: null, status: null },

        nationality: { value: initCountry, error: null, status: FIELD_STATUS.VALID },
        birthCountry: { value: initCountry, error: null, status: FIELD_STATUS.VALID },
        //id or passport
        id: { value: null, error: null, status: null },
        expiryDate: {
            value: null,
            error: null,
            status: null,
            dependentValue: null,
            dependentField: 'nationality',
            validationCondition: (currentfield, dependentField) => nationalityLabel.includes(dependentField?.value),
        },
        // passportId: { value: null, error: null, status: null },

        dateOfBirth: { value: null, error: null, status: null },
        prominentPerson: { value: null, error: null, status: null },
        // placeOfBirth:{ value: null, error: null, status: null },

        //Residential Address
        streetAddress: { value: null, error: null, status: null },
        city: { value: null, error: null, status: null },
        country: { value: initCountry, error: null, status: FIELD_STATUS.VALID },

        residenceTimePeriod: { value: null, error: null, status: null },

        //Previous Residential Address
        previousPostalAddress: {
            value: null,
            error: null,
            status: null,
            dependentValue: 'Less than two years',
            dependentField: 'residenceTimePeriod',
        },
        previousPostalCity: {
            value: null,
            error: null,
            status: null,
            dependentValue: 'Less than two years',
            dependentField: 'residenceTimePeriod',
        },
        previousPostalCountry: {
            value: null,
            error: null,
            status: null,
            dependentValue: 'Less than two years',
            dependentField: 'residenceTimePeriod',
        },

        //Postal Address
        postalSuburb: { value: null, error: null, status: null },
        postalCity: { value: null, error: null, status: null },
        postalCountry: { value: initCountry, error: null, status: FIELD_STATUS.VALID },

        //Empoyment Details
        employementType: { value: null, error: null, status: null },
        employeeOccupation: {
            value: null,
            error: null,
            status: null,
            dependentField: 'employementType',
            dependentValue: null,
            validationCondition: (currentfield, dependentField) =>
                ['Employed', 'Self Employed'].includes(dependentField?.value),
        },
        otherEmployeeOccupation: {
            value: null,
            error: null,
            status: null,
            dependentField: 'employeeOccupation',
            dependentValue: 'Other',
        },
        sourceOfIncome: { value: null, error: null, status: null },
        otherSourceOfIncome: {
            value: null,
            error: null,
            status: null,
            dependentField: 'sourceOfIncome',
            dependentValue: 'Other',
        },

        //Contact Details
        mobileNumber: { value: null, error: null, status: null },
        email: { value: null, error: null, status: FIELD_STATUS.VALID },
        telephoneWork: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            dependentField: 'employementType',
            dependentValue: 'Employed',
        },
    },
};
export default (state = initPurchasePersonalDetails, action) => {
    const trimField = (value) => (value ? value.trim() : value);
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    // if ( CLAIMENT_DETAILS_SET_VALUE) {
    switch (action.type) {
        case FORM_VALID_TRANSITION_PURCHASE_PERSONAL_DETAILS:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case FORM_INVALID_TRANSITION_PURCHASE_PERSONAL_DETAILS:
            return { ...state, formStatus: FORM_STATUS.INVALID };
        case PURCHASE_PERSONAL_DETAILS_SET_VALUE:
            if (action.value.fieldType === 'nationality') {
                return {
                    ...state,
                    form: {
                        ...state.form,
                        nationality: { ...state.form.nationality, value: action.value.value },
                        id: { value: null, error: null, status: null },
                    },
                };
            }
            return updateFormField(action.value.fieldType, (field) => ({
                ...field,
                value: action.value.value,
            }));
        case PURCHASE_PERSONAL_DETAILS_SET_VALUE_WITHOUT_VALIDATION:
            return updateFormField(action.value.fieldType, (field) => ({
                ...field,
                value: action.value.value,
                displayVAlue: action.value.value,
                error: null,
                status: null,
            }));

        case PURCHASE_PERSONAL_DETAILS_SET_VALID:
            const { fieldType, error } = action;
            return updateFormField(fieldType, (field) => ({
                ...field,
                error: error,
                status: mapError(error),
            }));
        case PURCHASE_PERSONAL_DETAILS_EDIT:
            return { ...state, isPurchasePersonalDetailsEdit: action.value };
        default:
            return state;
        // }
    }
};
